<!--
Author: TangChen
Date: 2018-12-26
Desc: 定投基金详情，由index.js 配置引入
-->
<template>
    <div>
        <comp-title-dc back-url-name="myplan" :back-url-query="{ planType: 0 }">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item v-if="!$util.belongHx()" :to="{ path: '/home' }">
                    我的账户
                </el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/myplan' }">我的定投</el-breadcrumb-item>
                <el-breadcrumb-item
                    :to="{
                        path: '/myplan?planType=' + planType
                    }"
                >
                    {{ planTypeArr[planType] }}
                </el-breadcrumb-item>
                <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title-dc>
        <div class="bizcomp-plan-detail bizcomp">
            <div class="plan-desc-contain">
                <div class="plan-desc-content">
                    <div class="plan-desc-head">
                        <div class="my-plan-achieve">
                            <img
                                class="plan-achieve-img"
                                src="../../assets/img/my-plan-log.png"
                                alt=""
                            />
                            <span class="plan-achieve-text">我的定投成就</span>
                        </div>
                        <div class="plan-status">
                            <span class="plan-status-title">定投状态：</span>
                            <span class="plan-status-value">
                                {{ formatterStatus(fund.status) }}
                            </span>
                        </div>
                    </div>
                    <div class="plan-total-info">
                        <div class="total-info-time">
                            <div class="color-fd6112-bold">
                                {{ headData.planTime }}
                            </div>
                            <div class="color-f79472">定投设置时长</div>
                        </div>
                        <div class="total-info-num">
                            <div class="color-fd6112-bold">{{ headData.planNum }}期</div>
                            <div class="color-f79472">扣款成功期数</div>
                        </div>
                        <div class="total-info-money">
                            <div class="color-fd6112-bold">
                                {{ $util.fmtNum(headData.planMoney) }}元
                            </div>
                            <div class="color-f79472">成功扣款总额</div>
                        </div>
                    </div>
                </div>
                <div class="fund-desc-infos">
                    <div class="fund-desc-info1">
                        <div class="fund-desc">
                            <div class="fund-desc-name">
                                {{ fund.fundshortname || fund.fundname }}
                            </div>
                            <div class="fund-desc-code">
                                {{ fund.fundcode }}
                            </div>
                            <div class="fund-desc-sharetype">
                                {{
                                    fund.sharetype == "A"
                                        ? "前端收费"
                                        : fund.sharetype == "B"
                                        ? "后端收费"
                                        : ""
                                }}
                            </div>
                        </div>
                        <div
                            class="fund-page-btn"
                            v-on:click.stop="gotoDetail(fund.fundcode, fund.producttype)"
                        >
                            基金详情
                            <i class="el-icon-arrow-right" ria-hidden="true"></i>
                        </div>
                    </div>
                    <div class="fund-desc-info2 font-14">
                        <div class="width-146">
                            <div class="color-666">
                                {{ planType == "2" ? "基础金额" : "扣款金额" }}
                            </div>
                            <div class="color-333">
                                {{ formatterNum(fund.firstinvestamount) }}
                            </div>
                        </div>
                        <div class="width-146">
                            <div class="color-666">扣款账户</div>
                            <div class="color-333">
                                {{
                                    $cache.getDict("110080", fund.bankcode).substr(-4, 4) +
                                    "(" +
                                    fund.depositcard.substr(-4, 4) +
                                    ")"
                                }}
                            </div>
                        </div>
                        <div class="width-146">
                            <div class="color-666">扣款时间</div>
                            <div class="color-333">
                                {{ formatterCycle(fund) }}
                            </div>
                        </div>
                        <div class="width-146">
                            <div class="color-666">预计下次扣款时间</div>
                            <div class="color-333">
                                {{ $util.fmtDate(fund.nextinvestdate) }}
                            </div>
                        </div>
                    </div>
                    <div v-if="!$util.belongHx()" class="fund-desc-btns">
                        <div
                            v-if="
                                fund.statusText.indexOf('c') > -1 &&
                                fund.statusText.indexOf('s') === -1
                            "
                            class="fund-desc-btn"
                            v-on:click.prevent="btnAction('c')"
                        >
                            修改
                        </div>
                        <div
                            v-if="fund.statusText.indexOf('s') > -1"
                            class="fund-desc-btn"
                            v-on:click.prevent="btnAction('s')"
                        >
                            恢复
                        </div>

                        <div
                            v-if="fund.statusText.indexOf('p') > -1"
                            class="fund-desc-btn magin-left"
                            v-on:click.prevent="btnAction('p')"
                        >
                            暂停
                        </div>
                        <div
                            v-if="fund.statusText.indexOf('e') > -1"
                            class="fund-desc-btn magin-left"
                            v-on:click.prevent="btnAction('e')"
                        >
                            终止
                        </div>
                        <el-tooltip
                            v-else
                            class="item"
                            effect="info"
                            :content="'定投状态为' + formatterStatus(fund.status) + ',不允许操作'"
                            placement="right"
                        >
                            <div class="fund-desc-btn">终止</div>
                        </el-tooltip>
                    </div>
                </div>
            </div>
            <plan-deduction-dc></plan-deduction-dc>
        </div>
        <msg-dialog
            v-if="dialog"
            :dialog="dialog"
            :private-info="wisdomInfo"
            v-on:event-fn="btnDialog"
        />
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import msgDialog from "@/components/misc/msgDialog";
import format from "date-fns/format";
import fundApi from "@/api/fund";
import planDeductionDc from "@/bizcomponents/general/planDeductionDc.vue";
export default {
    name: "PlanDetail",
    components: {
        msgDialog,
        planDeductionDc
    },
    mixins: [mixin],
    data() {
        return {
            fund: {},
            wisdomInfo: {},
            dialog: false,
            cancelOrderId: "",
            planType: "0",
            planTypeArr: {
                1: "普通定投",
                7: "目标盈定投",
                4: "智能定投",
                3: "组合定投"
            },
            headData: {
                planTime: "",
                planNum: "",
                planMoney: ""
            }
        };
    },
    created() {
        // 获取基金信息
        this.fund = JSON.parse(sessionStorage.getItem(this.$route.name));
        const dateTime = new Date(this.$util.fmtDate(this.fund.operdate));
        const dateTimeToday = new Date();
        const oneDay = 24 * 60 * 60 * 1000; // 一天的毫秒数
        const differenceInDays = Math.round(Math.abs((dateTimeToday - dateTime) / oneDay));
        this.headData.planTime = this.getYearsMonthsDays(differenceInDays);
        this.headData.planNum = this.fund.totalsucctimes;
        this.headData.planMoney = this.fund.totalsuccamount;
        this.planType = this.$route.query.planType;
        this.getNewFund();
    },
    methods: {
        async gotoDetail(val, producttype) {
            let fundclass = producttype;
            if (!fundclass) {
                let res = await fundApi.qryFundClass({
                    fundcode: val,
                    pagesize: "1",
                    pagenum: "1",
                    fundclass: "*"
                });
                if (res.data && res.data.list && res.data.list.length) {
                    const fund = res.data.list[0];
                    fundclass = fund.fundclass;
                }
            }
            this.$util.toFundDetail(val, fundclass == 0);
        },
        getYearsMonthsDays(totalDays) {
            let years = 0;
            let months = 0;
            let remainingDays = totalDays;
            while (remainingDays >= 365) {
                // 当剩余天数大于或等于一年的天数时
                remainingDays -= 365; // 减去一年的天数
                years++; // 年份增加
            }
            while (remainingDays >= 30) {
                // 当剩余天数大于或等于一个月的天数时
                remainingDays -= 30; // 减去一个月的天数
                months++; // 月份增加
            }
            if (years > 0) {
                return years + "年" + months + "个月";
            } else {
                if (months > 0) {
                    return months + "个月" + remainingDays + "日";
                } else {
                    return remainingDays + "日";
                }
            }
        },
        formatterStatus(value) {
            if (value == "N") {
                return "正常";
            } else if (value == "P") {
                return "暂停";
            } else {
                return "终止";
            }
        },
        formatterNum(value) {
            if (value.indexOf(",") > -1) {
                const _x = value.split(",");
                let _z = "";
                // 定转显示
                for (let i in _x) {
                    _z += this.$util.fmtNum(_x[i]) + "</br>";
                }
                return _z;
            }
            return this.$util.fmtNum(value);
        },
        formatterCycle(row) {
            if (!row.investcycle || !row.investcyclevalue) {
                return "";
            }
            const cyclestr =
                (row.investcycle == "2" ? "每" : "") +
                this.$cache.getDict("110009", row.investcycle); // 0-月，1-周，2-双周，3-每日
            let valuestr;
            if (row.investcycle == "0") {
                valuestr = row.investcyclevalue + "日";
            } else if (row.investcycle == "3") {
                valuestr = "";
            } else {
                valuestr = "星期" + row.investcyclevalue;
            }
            return cyclestr + (this.$util.isEmpty(valuestr) ? "" : valuestr);
        },
        // 获取基金可用操作
        getNewFund() {
            const acctStatus = this.$cache.getUser().status;
            const status = this.fund.status;
            const planStyle = this.fund.planflag;
            let btnArr = "";
            // 组合定投
            if (planStyle === "a" || planStyle === "b") {
                if (status === "N") {
                    btnArr = "e";
                } else if (status === "P") {
                    if (acctStatus === "7") {
                        btnArr = "e";
                    } else {
                        btnArr = "s,e";
                    }
                }
            } else {
                // 普通定投
                if (status === "N") {
                    if (acctStatus === "7") {
                        btnArr = "p,e";
                    } else {
                        btnArr = "c,p,e";
                    }
                } else if (status === "P") {
                    if (acctStatus === "7") {
                        btnArr = "e";
                    } else {
                        btnArr = "c,s,e";
                    }
                }
            }
            this.fund.statusText = btnArr;
        },
        // 按钮响应处理
        btnAction(cate) {
            if (cate === "c" || cate === "s") {
                this.fund.proto = "plan";
                this.$util.fundRiskCheck(this, this.fund, (res) => {
                    if (res) {
                        let _url = "";
                        let _way = "";
                        if (cate === "s") {
                            _url = "generalrecovery";
                            _way = "G2";
                        } else if (cate === "c") {
                            // 修改放下一版本
                            _url = "generalchange";
                            _way = "61";
                        }
                        const _x = Object.assign({}, res, { way: _way });
                        sessionStorage.setItem(_url, JSON.stringify(_x));
                        this.$router.push({
                            name: _url,
                            query: { fundcode: _x.fundcode }
                        });
                    }
                });
                return;
            }
            let _x = { method: "PUT" };
            if (cate === "p") {
                _x.cateText = "暂停";
                _x.url = "trade/plan/pause";
                _x.way = "G1";
                _x.action = "pause";
            } else if (cate === "e") {
                _x.cateText = "终止";
                _x.url = "trade/plan/recovery";
                _x.way = "60";
                _x.action = "close";
            } else if (cate === "cl") {
                _x.cateText = "撤销";
                _x.url = "trade/cancel";
                _x.method = "POST";
            }
            _x.cate = cate;
            let fundname = this.fund.fundshortname || this.fund.fundname;
            _x.msg =
                "您确定执行" +
                fundname +
                "(" +
                this.fund.fundcode +
                ")基金" +
                _x.cateText +
                "定投协议操作？";
            _x.tit = _x.cateText + "定投协议提示";
            _x.tit = _x.cateText + "定投协议提示";
            _x.btn1 = "确认" + _x.cateText;
            _x.btn2 = "取消";
            this.wisdomInfo = _x;
            this.dialog = true;
        },
        // 按钮弹窗提示信息
        async btnDialog(val) {
            const _this = this;
            if (val) {
                let _x = {
                    planno: this.fund.planno,
                    transactionaccountid: this.fund.transactionaccountid,
                    action: val.action,
                    tradepassword: val.tpasswd
                };
                if (val.cate === "cl") {
                    _x = {
                        orderid: this.cancelOrderId,
                        tradepwd: val.tpasswd || ""
                    };
                }
                // 组合定投终止
                if (this.fund.planflag === "a" || this.fund.planflag === "b") {
                    _x.saveplanflag = this.fund.planflag;
                    _x.planno = this.fund.planno;
                }
                const res = await fundApi.planOperation(_x);
                if (val.cate === "cl") {
                    this.$router.push({ name: "myplan" });
                }
                if (res.data) {
                    _this.getFundInfo(_this.fund);
                }
            } else {
                this.dialog = false;
            }
        },
        // 获取定投协议信息
        async getFundInfo(data) {
            const res = await fundApi.getPlan({
                fundcode: data.fundcode
            });
            if (res.data && res.data.data) {
                const val = res.data.data.find((item) => {
                    return item.planno === data.planno;
                });
                if (!val) {
                    return;
                }
                if (val.comrate === "0.0000" || (val.mainplanno && val.mainplanno.trim() === "")) {
                    val.comrate = "";
                }
                if (data.planflag === "a" || data.planflag === "b") {
                    this.fund = Object.assign({}, data, {
                        planname: val.planname,
                        status: val.status
                    });
                } else {
                    this.fund = Object.assign({}, data, val);
                }
                const _x = Object.assign({}, this.fund);
                sessionStorage.setItem("plandetail", JSON.stringify(_x));
                this.getNewFund();
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.bizcomp-plan-detail {
    background: #ffffff;
    border: 1px solid #f1f1f1;
    .plan-desc-contain {
        padding: 20px 21px 0;
    }
    .plan-desc-content {
        background: linear-gradient(0deg, #faf2ec 0%, #ffe6d5 100%);
        border-radius: 6px;
        .plan-desc-head {
            display: flex;
            justify-content: space-between;
            .my-plan-achieve {
                width: 272px;
                height: 54px;
                display: flex;
                align-items: center;
                border-radius: 6px 0px 40px 0px;
                padding-left: 21px;
                background: linear-gradient(180deg, #ffe9da 0%, #fad8c2 100%);
                .plan-achieve-text {
                    padding-left: 6.29px;
                    font-size: 26px;
                    font-weight: bold;
                    color: #e84e00;
                }
            }
            .plan-status {
                padding-right: 16px;
                height: 54px;
                line-height: 54px;
                .plan-status-title {
                    font-size: 16px;
                    color: #f79472;
                }
                .plan-status-value {
                    font-size: 16px;
                    font-weight: 500px;
                    color: #fd6112;
                }
            }
        }
        .plan-total-info {
            display: flex;
            justify-content: center;
            height: 126px;
            align-items: center;
            .total-info-time {
                flex: 1;
                text-align: center;
            }
            .total-info-num {
                flex: 1;
                text-align: center;
                border-left: 1px solid #ffd6ba;
                border-right: 1px solid #ffd6ba;
            }
            .total-info-money {
                flex: 1;
                text-align: center;
            }
            font-size: 20px;
        }
    }
    .fund-desc-infos {
        padding: 19px 16px;
        background: #ffffff;
        margin-top: 20px;
        border: 1px solid #f1f1f1;
        .fund-desc-info1 {
            display: flex;
            align-items: center;
            justify-content: space-between;
            .fund-desc {
                display: flex;
                height: 20px;
                line-height: 20px;
                .fund-desc-name {
                    font-size: 16px;
                    font-weight: bold;
                    color: #333333;
                }
                .fund-desc-code {
                    padding: 0 7px;
                    font-size: 14px;
                    color: #999999;
                }
                .fund-desc-sharetype {
                    font-size: 14px;
                    color: #999999;
                }
            }

            .fund-page-btn {
                cursor: pointer;
                font-size: 14px;
                color: #007cee;
                display: flex;
                align-items: center;
            }
        }
        .fund-desc-info2 {
            display: flex;
            margin-top: 22px;
        }
        .fund-desc-btns {
            display: flex;
            margin-top: 20px;
            .fund-desc-btn {
                cursor: pointer;
                width: 106px;
                text-align: center;
                height: 32px;
                line-height: 32px;
                border-radius: 2px;
                color: #e60012;
                background: #ffffff;
                box-sizing: border-box;
                border: 1px solid #d9d9d9;
            }
            .fund-desc-btn:hover {
                color: #ffffff;
                background: #e60012;
                box-sizing: border-box;
                border: 1px solid #e60012;
            }
        }
    }
    .magin-left {
        margin-left: 10px;
    }
    .color-fd6112-bold {
        font-weight: bold;
        font-size: 20px;
        color: #fd6112;
    }
    .color-f79472 {
        font-size: 16px;
        color: #f79472;
    }
    .width-146 {
        width: 146px;
    }
    .color-666 {
        color: #666666;
    }
    .color-333 {
        color: #333333;
    }
    .font-14 {
        font-size: 14px;
    }
}
</style>
